export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.nominal-loyalty.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.nominal-loyalty.aria-label',
    },
    moreInformation: {
      id: 'admin/promotions.form.regular.editor.benefit.nominal-loyalty.more-information',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.nominal-loyalty.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
